(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pimsoo-pattern-gift"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pimsoo-pattern-gift')) {
    customElements.define('pimsoo-pattern-gift', class extends HTMLElement {
      #events;
      #observer;
      #resize;
      #frame;
      #dismissed = false;
      #dialog;
      #launcher;
      #opener;
      #launcherTimer;
      #launcherReady = false;
      #entrancePlayed = false;
      #captchaSuspended = false;
      #requestedOpen = false;
      #switchClosures = 0;
      #restoreTimer;
      #captchaTimer;
      #scrim;
      #isolatedElements = new Set();

      connectedCallback() {
        this.#releaseBackground();
        this.#events?.abort();
        this.#observer?.disconnect();
        this.#resize?.disconnect();
        cancelAnimationFrame(this.#frame);
        this.#frame = null;
        clearTimeout(this.#restoreTimer);
        clearInterval(this.#captchaTimer);
        clearTimeout(this.#launcherTimer);
        this.#launcherTimer = null;
        this.#launcherReady = false;
        this.#entrancePlayed = false;
        this.#restoreTimer = null;
        this.#switchClosures = 0;
        this.#requestedOpen = false;
        this.#captchaSuspended = false;
        this.#events = new AbortController();
        this.#dialog = this.querySelector('dialog');
        this.#launcher = this.querySelector('[data-launcher]');
        this.#opener = this.querySelector('[data-open]');
        this.#scrim = this.querySelector('[data-challenge-scrim]');
        if (!this.#dialog?.showModal) return;
        try { this.#dismissed = this.dataset.editor !== 'true' && sessionStorage.getItem('pimsoo-pattern-gift-dismissed') === '1'; } catch {}
        const options = { signal: this.#events.signal };
        const finishEntrance = () => this.#launcher.classList.remove('pimsoo-pattern-gift__launcher--entering');
        finishEntrance();
        this.#launcher.addEventListener('animationend', event => {
          if (event.target === this.#launcher) finishEntrance();
        }, options);
        this.#launcher.addEventListener('focusin', finishEntrance, options);
        this.#opener.addEventListener('click', () => {
          this.#requestedOpen = true;
          this.#dialog.showModal();
          document.documentElement.classList.add('pimsoo-pattern-gift-modal-open');
          clearInterval(this.#captchaTimer);
          this.#captchaTimer = setInterval(() => this.#syncCaptcha(), 250);
          this.#syncCaptcha();
        }, options);
        const closeGift = () => {
          this.#requestedOpen = false;
          this.#releaseBackground();
          clearTimeout(this.#restoreTimer);
          clearInterval(this.#captchaTimer);
          this.#dialog.close();
        };
        this.querySelector('[data-close]').addEventListener('click', closeGift, options);
        this.#scrim.addEventListener('click', closeGift, options);
        this.querySelector('[data-dismiss]').addEventListener('click', () => {
          this.#dismissed = true;
          this.#launcher.hidden = true;
          finishEntrance();
          try { if (this.dataset.editor !== 'true') sessionStorage.setItem('pimsoo-pattern-gift-dismissed', '1'); } catch {}
        }, options);
        this.#dialog.addEventListener('close', () => {
          if (this.#switchClosures > 0) {
            this.#switchClosures--;
            return;
          }
          if (this.#requestedOpen && this.#dialog.open) return;
          this.#requestedOpen = false;
          this.#captchaSuspended = false;
          this.#releaseBackground();
          this.#scrim.hidden = true;
          clearTimeout(this.#restoreTimer);
          clearInterval(this.#captchaTimer);
          document.documentElement.classList.remove('pimsoo-pattern-gift-modal-open');
          if (!this.#launcher.hidden) this.#opener.focus({ preventScroll: true });
        }, options);
        this.#dialog.addEventListener('cancel', () => {
          this.#requestedOpen = false;
          this.#releaseBackground();
          clearTimeout(this.#restoreTimer);
          clearInterval(this.#captchaTimer);
        }, options);
        this.#dialog.addEventListener('keydown', event => {
          if (this.#captchaSuspended && event.key === 'Escape') closeGift();
        }, options);
        document.addEventListener('focusin', event => {
          if (!this.#captchaSuspended || !this.#requestedOpen || !this.#dialog.open) return;
          const challenge = this.#visibleChallenge();
          if (!challenge || event.composedPath().includes(this.#dialog) || event.target === challenge) return;
          challenge.focus({ preventScroll: true });
        }, { ...options, capture: true });
        this.#dialog.addEventListener('click', event => {
          if (event.target !== this.#dialog) return;
          const rect = this.#dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeGift();
        }, options);
        const preview = this.querySelector('[data-preview-form]');
        preview?.addEventListener('submit', event => event.preventDefault(), options);
        this.querySelector('[data-preview-submit]')?.addEventListener('click', () => preview.reportValidity(), options);
        const update = () => {
          this.#syncCaptcha();
          if (this.#frame != null) return;
          this.#frame = requestAnimationFrame(() => {
            this.#frame = null;
            this.#syncLauncher();
          });
        };
        this.#observer = new MutationObserver(update);
        this.#observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
        this.#observer.observe(document.body, { childList: true, subtree: true });
        for (const element of document.querySelectorAll('az-cart-drawer, .az-cookie-banner, #shopify-pc__banner, .az-sticky-addtocart, .az-mobile-sticky-bar')) {
          this.#observer.observe(element, { attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
        }
        this.#resize = new ResizeObserver(update);
        for (const element of document.querySelectorAll('.az-sticky-addtocart, .az-mobile-sticky-bar')) {
          this.#resize.observe(element);
          element.addEventListener('transitionend', update, options);
        }
        window.addEventListener('resize', update, options);
        document.addEventListener('load', event => {
          if (event.target instanceof HTMLIFrameElement) update();
        }, { ...options, capture: true });
        this.#syncLauncher();
        if (this.dataset.editor === 'true') {
          this.#launcherReady = true;
          this.#syncLauncher();
        } else {
          const scheduleLauncher = () => {
            this.#launcherTimer = setTimeout(() => {
              this.#launcherTimer = null;
              if (!this.isConnected) return;
              this.#launcherReady = true;
              this.#syncLauncher();
            }, 3000);
          };
          if (document.readyState === 'complete') scheduleLauncher();
          else window.addEventListener('load', scheduleLauncher, { ...options, once: true });
        }
      }

      #syncLauncher() {
        this.#syncCaptcha();
        const cartOpen = document.querySelector('.az-cart-drawer--active');
        const cookies = document.querySelectorAll('.az-cookie-banner, #shopify-pc__banner');
        let cookieOpen = false;
        for (const cookie of cookies) {
          const rect = cookie.getBoundingClientRect();
          if (rect.height > 0 && getComputedStyle(cookie).display !== 'none') cookieOpen = true;
          this.#observer.observe(cookie, { attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
        }
        let offset = 0;
        for (const element of document.querySelectorAll('.az-sticky-addtocart, .az-mobile-sticky-bar')) {
          const rect = element.getBoundingClientRect();
          if (rect.top < window.innerHeight && rect.bottom > 0 && rect.height > 0) offset = Math.max(offset, window.innerHeight - rect.top);
        }
        const mobile = window.matchMedia('(max-width: 749px)').matches;
        this.#launcher.hidden = !this.#launcherReady || this.#dismissed || Boolean(cartOpen) || Boolean(cookieOpen) || (mobile && offset > 0);
        if (this.#launcher.hidden) {
          this.#launcher.classList.remove('pimsoo-pattern-gift__launcher--entering');
        } else if (!this.#entrancePlayed) {
          this.#entrancePlayed = true;
          if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) this.#launcher.classList.add('pimsoo-pattern-gift__launcher--entering');
        }
        const configured = parseFloat(getComputedStyle(this).getPropertyValue('--gift-mobile-offset')) || 16;
        this.#launcher.style.setProperty('--gift-mobile-offset', `${configured}px`);
        this.#launcher.style.setProperty('--gift-desktop-offset', `${Math.max(24, offset + 16)}px`);
      }

      #syncCaptcha() {
        if (!this.#requestedOpen || !this.#dialog?.open || !this.isConnected) return;
        const challenge = this.#visibleChallenge();
        if (challenge) {
          clearTimeout(this.#restoreTimer);
          this.#restoreTimer = null;
          if (!this.#captchaSuspended) {
            this.#switchDialog(false);
            challenge.focus({ preventScroll: true });
          }
          if (this.#captchaSuspended) this.#isolateBackground(challenge);
        } else if (this.#captchaSuspended && !this.#restoreTimer) {
          this.#restoreTimer = setTimeout(() => {
            this.#restoreTimer = null;
            if (this.isConnected && this.#requestedOpen && this.#dialog.open && !this.#visibleChallenge()) this.#switchDialog(true);
          }, 400);
        }
      }

      #visibleChallenge() {
        let challenge;
        for (const frame of document.querySelectorAll('iframe')) {
          this.#observer?.observe(frame, { attributes: true, attributeFilter: ['src', 'class', 'style', 'hidden'] });
          if (this.contains(frame)) continue;
          let host;
          try { host = new URL(frame.src).hostname; } catch { continue; }
          if (host !== 'hcaptcha.com' && !host.endsWith('.hcaptcha.com')) continue;
          const rect = frame.getBoundingClientRect();
          const frameStyles = getComputedStyle(frame);
          let visible = rect.width > 100 && rect.height > 100 && rect.right > 0 && rect.bottom > 0 && rect.left < window.innerWidth && rect.top < window.innerHeight && frameStyles.visibility === 'visible' && frameStyles.opacity !== '0';
          for (let container = frame.parentElement; container && container !== document.body; container = container.parentElement) {
            this.#observer?.observe(container, { attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
            const styles = getComputedStyle(container);
            if (styles.display === 'none' || styles.visibility === 'hidden' || styles.opacity === '0') visible = false;
          }
          if (visible) challenge = frame;
        }
        return challenge;
      }

      #switchDialog(modal) {
        const scrollTop = this.#dialog.scrollTop;
        if (modal) this.#releaseBackground();
        try {
          this.#switchClosures++;
          this.#dialog.close();
          if (modal) this.#dialog.showModal();
          else this.#dialog.show();
          this.#dialog.scrollTop = scrollTop;
          this.#captchaSuspended = !modal;
          this.#scrim.hidden = modal;
        } catch {
          this.#requestedOpen = false;
          this.#captchaSuspended = false;
          this.#releaseBackground();
          this.#scrim.hidden = true;
          clearInterval(this.#captchaTimer);
          document.documentElement.classList.remove('pimsoo-pattern-gift-modal-open');
          this.#dialog.close();
        }
      }

      #isolateBackground(challenge) {
        const next = new Set();
        const visit = container => {
          for (const element of container.children) {
            if (!(element instanceof HTMLElement)) continue;
            if (element === this.#dialog || element === this.#scrim || element === challenge) continue;
            if (element.contains(this.#dialog) || element.contains(challenge)) {
              visit(element);
              continue;
            }
            if (!['SCRIPT', 'STYLE', 'LINK'].includes(element.tagName)) next.add(element);
          }
        };
        visit(document.body);
        for (const element of this.#isolatedElements) {
          if (next.has(element)) continue;
          element.inert = false;
          this.#isolatedElements.delete(element);
        }
        for (const element of next) {
          if (element.inert) continue;
          element.inert = true;
          this.#isolatedElements.add(element);
        }
      }

      #releaseBackground() {
        for (const element of this.#isolatedElements) element.inert = false;
        this.#isolatedElements.clear();
      }

      disconnectedCallback() {
        this.#releaseBackground();
        this.#events?.abort();
        this.#observer?.disconnect();
        this.#resize?.disconnect();
        cancelAnimationFrame(this.#frame);
        this.#frame = null;
        clearTimeout(this.#restoreTimer);
        clearInterval(this.#captchaTimer);
        clearTimeout(this.#launcherTimer);
        this.#launcherTimer = null;
        this.#launcherReady = false;
        this.#entrancePlayed = false;
        if (this.#launcher) {
          this.#launcher.hidden = true;
          this.#launcher.classList.remove('pimsoo-pattern-gift__launcher--entering');
        }
        this.#restoreTimer = null;
        this.#switchClosures = 0;
        this.#requestedOpen = false;
        this.#captchaSuspended = false;
        if (this.#scrim) this.#scrim.hidden = true;
        document.documentElement.classList.remove('pimsoo-pattern-gift-modal-open');
        this.#dialog?.close();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
